import { isSameDateOnDay } from "./dates";

/**
 * Получить item из массива по полю
 * @param {String} fiaeldName Название поля, по которому идёт поиск
 * @param {*} fieldValue Значение поиска
 * @param {Array} listItems Массив, по которому будет произведён поиск
 * @returns {Object|null} Найденный/не найденный элемент
 */
export function getItemFromArrayOnCreatedAt(fiaeldName, fieldValue, listItems) {
  let returnItem = null;

  for (let item of listItems) {
    if (item[fiaeldName]) {
      if (fiaeldName === "created_at" || fiaeldName === "updated_at") {
        if (isSameDateOnDay(item[fiaeldName], fieldValue)) {
          returnItem = item;
        }
      } else if (item[fiaeldName] === fieldValue) {
        returnItem = item;
      }
    }
  }

  return returnItem;
}
